import React from 'react';
import ListStyleOne from '../../components/list-style/one';
import HomeContentSection from '../Home/HomeContentSection';
import Clients from '../Industries/Industry/Clients';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';
import {colors} from '../../style/constants';
import QmFeaturesSection from './QmFeaturesSection';
import QmHardwareSection from './QmHardwareSection';

const useStyles = makeStyles(() => ({
  catchphrase: {
    background: colors.LIGHT_GREY,
  },
  carousel: {
    paddingTop: 0,
  },
}));

const Qm = (props) => {
  const classes = useStyles();
  return (
    <>
      <QmFeaturesSection lang={props.lang} features={props.features}/>
      <QmHardwareSection lang={props.lang}/>
      <section id='qm-projects-types'>
        <ListStyleOne lang={props.lang} align='left' items={props.types.edges[0]} QM/>
        <ListStyleOne lang={props.lang} align='right' items={props.types.edges[1]} QM/>
        <ListStyleOne lang={props.lang} align='left' items={props.types.edges[2]} QM/>
      </section>
      <section className={classes.catchphrase + " clipped"}>
      <Container className={classes.container}>
        <h2>{props.lang === 'en-CA' ? 'Innovation is at your doorstep and we have everything you need to make your project happen.' :'L’innovation est à vos portes et nous avons tout ce qu’il faut pour réaliser le projet avec vous.'}</h2>
      </Container>
    </section>
       <section className={classes.carousel}>
        <Container>
          <Clients lang={props.lang} items={props.carouselDatas}/>
        </Container>
      </section>
      <HomeContentSection lang={props.lang}/>
    </>
  );
}
  
export default Qm;